import styled from 'styled-components';
 
interface StyledDivProps {
  backgroundimage?: string; // Define the type for the backgroundImage prop
  fliphorizontal?: boolean; // Add flipHorizontal prop to indicate horizontal flipping
}
 
export const StyledDiv = styled.div<StyledDivProps>`
  position: relative; // Make the container relative to use absolute positioning for pseudo-element
  width: 100%;
  border-top: 4px solid #00B8E5;
  background-image: url(${props => props.backgroundimage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  &::before { // Use a pseudo-element to handle background image flipping
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${props => props.backgroundimage});
    background-size: cover;
    background-position: 84%;
    background-repeat: no-repeat;
    transform: ${props => (props.fliphorizontal ? 'scaleX(-1)' : 'none')};
    // Apply flipping transformation
  }
`;